export default {
  GRID: {
    desktop: {
      Grid: "SEARCH_MEA_1",
      List: "SEARCH_MEA_1"
    },
    mobile: {
      Grid: "MOBILE_SEARCH_MEA_1",
      List: "MOBILE_SEARCH_MEA_1"
    }
  },
  FIRST_PUSH_MOBILE_GRID_MODE: 3,
  SECOND_PUSH_GRID_MODE: 3,
  LIST_COLUMN_NUMBER: 4,
  SEARCH_MEA: 'Search_Banniere_MEA'
}
